var _g, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActivateSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 128,
  height: 112,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 6.286A2.286 2.286 0 0 1 2.286 4h107.428A2.286 2.286 0 0 1 112 6.286V16H0V6.286Z",
  fill: "#8A8A8A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM99 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM106 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM0 16h112v67.714A2.286 2.286 0 0 1 109.714 86H2.286A2.286 2.286 0 0 1 0 83.714V16Z",
  fill: "#5E5E5E"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.286A2.286 2.286 0 0 1 10.286 14h107.428A2.286 2.286 0 0 1 120 16.286V26H8v-9.714Z",
  fill: "#8A8A8A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M100 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM107 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM114 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 26h112v67.714A2.286 2.286 0 0 1 117.714 96H10.286A2.286 2.286 0 0 1 8 93.714V26Z",
  fill: "#5E5E5E"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 88.001,
  r: 15,
  fill: "#212121"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M104 68c-2.76 0-5.352.522-7.773 1.563-2.448 1.042-4.584 2.474-6.407 4.297-1.797 1.796-3.216 3.919-4.257 6.366C84.52 82.648 84 85.24 84 88s.52 5.351 1.563 7.773c1.041 2.448 2.46 4.583 4.257 6.406 1.823 1.796 3.959 3.215 6.407 4.257 2.421 1.042 5.013 1.562 7.773 1.562s5.352-.52 7.773-1.562c2.448-1.042 4.571-2.461 6.368-4.257 1.823-1.823 3.255-3.958 4.297-6.406 1.041-2.422 1.562-5.013 1.562-7.773s-.521-5.351-1.562-7.773c-1.042-2.447-2.474-4.57-4.297-6.366-1.797-1.823-3.92-3.255-6.368-4.297-2.421-1.041-5.013-1.562-7.773-1.562Zm-2.5 29.998L91.5 88l2.5-2.5 7.5 7.5 12.5-15 2.5 2.5-15 17.5Z",
  fill: "#04C45A"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#424242",
  d: "M21 41h69v4H21zM21 51h37v4H21z"
})));
export { SvgActivateSuccess as ReactComponent };
export default "/13a990c3346beecb682fa5f5a1c009e3.svg";